// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"2a5d7045","209":"08443fc0","829":"7c3c5e93","878":"5301cdc7"}[chunkId] + ".chunk.js";
};